import TreeCollection from '@hh.ru/magritte-ui-tree-selector/collection/treeCollection';
import { AdditionalDefault } from '@hh.ru/magritte-ui-tree-selector/collection/types';
import SelectionStrategy from '@hh.ru/magritte-ui-tree-selector/strategy/selectionStrategy';
import { StrategyOptions } from '@hh.ru/magritte-ui-tree-selector/strategy/types';

class ImmutableSelectionStrategy<Additional extends AdditionalDefault = never> {
    private strategy: SelectionStrategy<Additional>;

    constructor(collection: TreeCollection<Additional>, options: StrategyOptions) {
        this.strategy = new SelectionStrategy<Additional>(collection, options);
    }

    /**
     * Возвращает новый набор, в котором к `items` добавлены `addedItems`.
     * @param items Текущий набор.
     * @param addedItems Добавляемые элементы.
     */
    add(items: string[], addedItems: string[]): string[] {
        const result = new Set(items);
        this.strategy.add(result, addedItems);
        return [...result];
    }

    /**
     * Возвращает новый набор, в котором из `items` удалены `removedItems`.
     * @param items Текущий набор.
     * @param removedItems Удаляемые элементы.
     */
    remove(items: string[], removedItems: string[]): string[] {
        const result = new Set(items);
        this.strategy.remove(result, removedItems);
        return [...result];
    }
}

export default ImmutableSelectionStrategy;
